import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Store login
  userLogin(body: any){
    const URL = environment.apiUrl + 'dashboard/login';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get retailer list
  getRetailers(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/retailers';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Change password
  changeUserPassword(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/changeUserPassword';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

}
